import React from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { FormGroup } from '../../../../../../../components/form/FormGroup';
import { useNamespacedTranslation } from '../../../../../../../hooks/useNamespacedTranslation';
import { ContentDocumentLinkDataFragment } from '../../../../../__generated__/graphql';
import FlairIcon from '../../../../../../../atomic/atoms/FlairIcon';

type Props = {
  contentDocumentLinks: ReadonlyArray<ContentDocumentLinkDataFragment>;
};

const i18Path = 'approvalRequest.detailsSidebar';

export const RecordAttachments: React.FC<React.PropsWithChildren<Props>> = ({
  contentDocumentLinks,
}) => {
  const t = useNamespacedTranslation(i18Path);

  if (!contentDocumentLinks || contentDocumentLinks.length === 0) {
    return null;
  }

  return (
    <Row className="mt-2">
      <Col>
        <FormGroup>
          <Form.Label className="fw-bold">{t('attachments')}</Form.Label>
          {contentDocumentLinks.map((link) => {
            const fileName = link.ContentDocument.FileExtension
              ? `${link.ContentDocument.Title}.${link.ContentDocument.FileExtension}`
              : link.ContentDocument.Title;
            return (
              <div key={link.Id}>
                <a
                  target="_blank"
                  rel="noreferrer noopener"
                  href={link.downloadUrl || undefined}>
                  {fileName}
                  <span className="ms-2">
                    <FlairIcon size="xs" icon="external-link-outline" />
                  </span>
                </a>
              </div>
            );
          })}
        </FormGroup>
      </Col>
    </Row>
  );
};
